import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import { showDialog } from "@widgets/CommonDialog";

import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_EQP_REP_010 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async (searchData: any) => {
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();

      const params = {
        id: "sn_prd_eqp_rep_010_01",
        params: searchDataToUse,
      };

      const data: any = await fnGetDataSet(params);
      const A = data?.[0] ?? [];
      const B = data?.[1] ?? [];

      // const equipMap: Record<string, string> = {
      //   "18호기": "2-1호기",
      //   "19호기": "2-2호기",
      //   "20호기": "2-3호기",
      //   "21호기": "2-4호기",
      // };

      const result = A.map((row: any) => ({
        cd_equip: row.cd_equip,
        nm_equip: row.nm_equip,
        cd_grp_equip: row.cd_grp_equip,
        nm_equip_sort: row.nm_equip_sort,
        cd_symtom: row.cd_symtom,
        nm_flag: row.nm_flag,
        qt_runtm: Number(row.qt_runtm) || 0,
        qt_work: Number(row.qt_work) || 0,
        dc_ref: row.dc_ref ? Number(row.dc_ref).toLocaleString() : "",
        qt_error: Number(row.qt_error) || 0,
      }));

      const result2 = B.map((row: any) => ({
        cd_equip: row.cd_equip,
        qt_runtm: Number(row.qt_runtm) || 0,
        qt_work: Number(row.qt_work) || 0,
        dc_ref: row.dc_ref ? Number(row.dc_ref).toLocaleString() : "",
        qt_error: Number(row.qt_error) || 0,
      }));

      const mergedMap: Record<string, any> = {};

      result.forEach((row: any) => {
        mergedMap[row.cd_equip] = { ...row };
      });

      result2.forEach((row: any) => {
        if (!mergedMap[row.cd_equip]) {
          mergedMap[row.cd_equip] = {
            cd_equip: row.cd_equip,
            nm_equip: "",
            cd_grp_equip: "",
            nm_equip_sort: "",
            cd_symtom: "",
            nm_flag: "",
            qt_runtm: 0,
            qt_work: 0,
            dc_ref: "",
            qt_error: 0,
          };
        }

        mergedMap[row.cd_equip].qt_runtm += row.qt_runtm;
        mergedMap[row.cd_equip].qt_work += row.qt_work;
        mergedMap[row.cd_equip].qt_error += row.qt_error;

        if (!mergedMap[row.cd_equip].dc_ref && row.dc_ref) {
          mergedMap[row.cd_equip].dc_ref = row.dc_ref;
        }
      });

      Object.values(mergedMap).forEach((item: any) => {
        item.qt_runtm = Math.round(item.qt_runtm / 60);
        item.qt_tm =
          item.qt_runtm !== 0 ? Math.round(item.qt_work / item.qt_runtm) : 0;
      });

      setDataSources({
        grid1: Object.values(mergedMap),
      });
    } catch (error: any) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
            getRowStyle: (params: any) => {
              if (params.data?.nm_flag) {
                return {
                  backgroundColor: "#ffebee",
                  color: "red",
                };
              }
              return {};
            },
          }}
          //chartColumns={["qt", "am"]}
        />
      </div>
    </div>
  );
});

export default SN_PRD_EQP_REP_010;
